import React, { ReactElement, Component, useContext, useEffect, useState, Fragment, useMemo } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import "./workspace-overview.less";
import { Col, Row, Descriptions, Collapse, Table, Input, Button, Popover, Modal, Spin, Skeleton } from "antd";
import { left_menu_item, LeftMenuContext, menu_items } from "../../contexts/left-menu";
import { LeftMenuTitleContext } from "../../contexts/left-menu-title";
import { item } from "../../contexts/items";
import { WorkSpaceSelectedContext } from "../../contexts/workspace-selected";
import { NameSpaceSelectedContext } from "../../contexts/namespace-selected";
import { quota_type, QuotaContext, quota_type_item } from "../../contexts/quota-management";
import { namespaces_type_item, NamespaceContext } from "../../contexts/namespaces";
import { WorkspaceContext, workspaces_type_item } from "../../contexts/workspaces";
import { http_request, destroy_worker } from "../../worker/http-func";
import { workspace_info_type } from "../../contexts/workspace-info";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { LineChart, XAxis, YAxis, CartesianGrid, Legend, Line, Tooltip, ResponsiveContainer } from "recharts";
import BreadCrumbs from "../../components/breadcrumb/breadcrumb";
import { change_unit } from "../global/global";
import { SideFlyInContext } from "../../contexts/side-menu-fly-in";
import { withRouter } from "react-router";
import { ColumnProps } from "antd/es/table";
import { IsFreshContext } from "../../contexts/is_fresh";
import { ClusterSelectedContext } from "../../contexts/cluster-selected";
// import { select } from "../workspaces-list/table-list";
import DropdownMenuTop from "../../components/dropdown-menu-top/dropdown-menu-top";
import { MenuFoldOutlined, MenuUnfoldOutlined, SearchOutlined, ExportOutlined, RightOutlined, LoadingOutlined } from "@ant-design/icons";
import { metric_values_new, metric_values } from "../../worker/function/interfaces";
import { UserInfoContext, IUserInfoType } from "../../contexts/user-info";
import { TableListModalContext } from "../../components/table-list/table-list";
import { table_list_modal_type} from "../../contexts/table_list_modal";
import { DatacenternameContext } from "../../contexts/datacenter-name";
import { UnitContext } from "../../contexts/unit";
import { TypeNameContext } from "../../contexts/type_name";
import { formatDate } from "../../pages/user-management/user-util";
import { ThemeContext } from "../../contexts/theme";

const ExportJsonExcel = require("js-export-excel");
const { Panel } = Collapse;
// const { Option } = Select;

interface space_item {
  space: string;
  uid: string;
  name?: string;
  labels?: object;
}

export const PhysicalResourceQuotaUsage: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const workspace_selected: item | undefined = useContext(WorkSpaceSelectedContext)[0],
    namespace_selected: item | undefined = useContext(NameSpaceSelectedContext)[0],
    quotas: quota_type["items"] = useContext(QuotaContext)[0],
    [is_fresh, set_is_fresh]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useContext(IsFreshContext),
    [workspaces, set_workspaces]: [workspaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>>] = useContext(
      WorkspaceContext
    ),
    [namespaces, set_namespaces]: [namespaces_type_item[] | undefined, React.Dispatch<React.SetStateAction<namespaces_type_item[] | undefined>>] = useContext(
      NamespaceContext
    ),
    [table_list_modal, set_table_list_modal]: [table_list_modal_type, React.Dispatch<React.SetStateAction<table_list_modal_type>>] = useContext(
      TableListModalContext
    ),
    user_info: IUserInfoType = useContext(UserInfoContext)[0],
    unit_provide: string = useContext(UnitContext)[0],
    cluster_selected: item | undefined = useContext(ClusterSelectedContext)[0],
    datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
    [is_spinning, set_is_spinning]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
    [physical_resource_usage, set_physical_resource_usage]: [JSX.Element[], React.Dispatch<React.SetStateAction<JSX.Element[]>>] = useState<JSX.Element[]>(
      [] as JSX.Element[]
    ),
    [selectedRowKeys, set_selectedRowKeys]: [string[], React.Dispatch<React.SetStateAction<string[]>>] = useState<string[]>([]),
    [selectedRows, set_selectedRows]: [{}[], React.Dispatch<React.SetStateAction<{}[]>>] = useState<{}[]>([{}]),
    [visible, set_visible]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
    [filter_name, set_filter_name] = useState(""),
    [filter_bind_name, set_filter_bind_name] = useState(""),
    [will_filter_bind_name, set_will_filter_bind_name] = useState(""),
    [will_filter_name, set_will_filter_name] = useState(""),
    [page_size, set_page_size]: [number, React.Dispatch<React.SetStateAction<number>>] = useState<number>(20),
    [bind_page_size, set_bind_page_size]: [number, React.Dispatch<React.SetStateAction<number>>] = useState<number>(20),
    path = window.location.pathname,
    quota_select = useMemo(() => {
      return quotas.find((quota) => selectedRows?.length > 0 && path.includes("quotas") ? sessionStorage.getItem('quota') === quota.metadata.name : table_list_modal.quota_selected === quota.metadata.name)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quotas, table_list_modal]);

  useEffect(
    () => () => {
      destroy_worker();
    },
    []
  );
  useEffect(() => {
    const binded_workspaces =
        Array.isArray(workspaces) &&
        workspaces &&
        workspaces
          .filter((workspace) => workspace && workspace.spec && workspace.spec.workspacequota === quota_select?.metadata.name)
          .map((workspace) => ({ space: workspace.metadata.labels.name, uid: workspace.metadata.uid })),
      binded_namespaces =
        Array.isArray(namespaces) &&
        namespaces &&
        namespaces
          .filter((namespace) => namespace && namespace.metadata.labels && namespace.metadata.labels.namespacequota === quota_select?.metadata.name)
          .map((namespace) => ({ space: namespace.metadata.name, uid: namespace.metadata.uid })),
      is_workspace = path.indexOf("workspace") > -1,
      bind_spaces = is_workspace ? binded_workspaces : binded_namespaces;
    if (bind_spaces && bind_spaces.length === 0) set_selectedRowKeys([]);
    else bind_spaces && set_selectedRowKeys(bind_spaces.map((space) => space.uid));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, workspaces, namespaces, quota_select?.metadata.name, is_fresh]);

  useEffect((): void => {
    let quota_data = [
      {
        key: "compute_resource_quota",
        value: [
          // { key: "compute_resource_quota", value: "compute_resource_quota" },
          { key: "limitsCPU", value: "" },
          { key: "limitsMemory", value: "" },
          { key: "Empty", value: `&nbsp;` },
        ],
      },
      {
        key: "storage_resource_quota",
        value: [
          // { key: "storage_resource_quota", value: "storage_resource_quota" },
          { key: "limitsDisk", value: "" },
          { key: "PVC", value: "" },
          { key: "limitsRootfs", value: "" },
        ],
      },
      {
        key: "object_count_quota",
        value: [
          // { key: "object_count_quota", value: "object_count_quota" },
          { key: "services", value: "" },
          { key: "secrets", value: "" },
          { key: "configMaps", value: "" },
          { key: "pods", value: "" },
        ],
      },
    ];

    if (path.includes("overview")) {
      const workspace: workspaces_type_item | undefined = workspaces?.filter((workspace) => workspace_selected?.name === workspace.metadata.name)[0],
        namespace: namespaces_type_item | undefined = namespaces && namespaces.filter((namespace) => namespace_selected?.name === namespace.metadata.name)[0],
        quota_name: string | undefined =
          path.indexOf("workspace") > -1
            ? workspace && workspace.spec && workspace.spec.workspacequota
            : namespace && namespace.metadata.labels && namespace.metadata.labels.namespacequota,
        binded_quota = quotas.filter((quota) => quota.metadata.name === quota_name);
      if (binded_quota.length === 1) {
        const quota: string = binded_quota[0]?.metadata.name;
        set_table_list_modal((currentState) => ({ ...currentState, quota_selected: quota }));
        quota_data = [
          {
            key: "compute_resource_quota",
            value: [
              // { key: "compute_resource_quota", value: "compute_resource_quota" },
              { key: "limitsCPU", value: `${quota_select?.spec.quotas.limitCPU ? quota_select?.spec.quotas.limitCPU : "Unlimited"}` },
              { key: "limitsMemory", value: `${quota_select?.spec.quotas.limitMemory ? quota_select?.spec.quotas.limitMemory : "Unlimited"}` },
              { key: "Empty", value: `&nbsp;` },
            ],
          },
          {
            key: "storage_resource_quota",
            value: [
              // { key: "storage_resource_quota", value: "storage_resource_quota" },
              { key: "PVC Disk", value: `${quota_select?.spec.quotas.limitsDisk ? quota_select?.spec.quotas.limitsDisk : "Unlimited"}` },
              { key: "PVC", value: `${quota_select?.spec.quotas.persistentvolumeclaims ? quota_select?.spec.quotas.persistentvolumeclaims : "Unlimited"}` },
              { key: "limitsRootfs", value: `${quota_select?.spec.quotas.limitsRootfs ? quota_select?.spec.quotas.limitsRootfs : "Unlimited"}` },
            ],
          },
          {
            key: "object_count_quota",
            value: [
              // { key: "object_count_quota", value: "object_count_quota" },
              { key: "services", value: `${quota_select?.spec.quotas.services ? quota_select?.spec.quotas.services : "Unlimited"}` },
              { key: "secrets", value: `${quota_select?.spec.quotas.secrets ? quota_select?.spec.quotas.secrets : "Unlimited"}` },
              { key: "configMaps", value: `${quota_select?.spec.quotas.configmaps ? quota_select?.spec.quotas.configmaps : "Unlimited"}` },
              { key: "pods", value: `${quota_select?.spec.quotas.pods ? quota_select?.spec.quotas.pods : "Unlimited"}` },
            ],
          },
        ];
      } else {
        for (let i = 0; i < quota_data.length; i++) {
          for (let j = 1; j < quota_data[i].value.length; j++) {
            quota_data[i].value[j].value = quota_data[i].value[j].key.includes("&") ? "&nbsp;" : "Unlimited";
          }
        }
      }
    } else {
      quota_data = [
        {
          key: "compute_resource_quota",
          value: [
            // { key: "compute_resource_quota", value: "compute_resource_quota" },
            { key: "requestCPU", value: `${quota_select?.spec.quotas.requestCPU ? quota_select?.spec.quotas.requestCPU : "Unlimited"} Core` },
            { key: "limitsCPU", value: `${quota_select?.spec.quotas.limitCPU ? quota_select?.spec.quotas.limitCPU : "Unlimited"} Core` },
            {
              key: "requestMemory",
              value: `${
                  quota_select?.spec.quotas.requestMemory && quota_select?.spec.quotas.requestMemory !== "Unlimited"
                  ? change_unit(quota_select?.spec.quotas.requestMemory, unit_provide, false).toFixed(2)
                  : "Unlimited"
              } ${unit_provide}`,
            },
            {
              key: "limitsMemory",
              value: `${
                quota_select?.spec.quotas.limitMemory !== "Unlimited"
                  ? change_unit(quota_select?.spec.quotas.limitMemory, unit_provide, false).toFixed(2)
                  : "Unlimited"
              } ${unit_provide}`,
            },
            { key: "GPU", value: `${quota_select?.spec.quotas.gpu ? quota_select?.spec.quotas.gpu : "Unlimited"}`  },
            { key: "Empty01", value: `&nbsp;` },
          ],
        },
        {
          key: "storage_resource_quota",
          value: [
            // { key: "storage_resource_quota", value: "storage_resource_quota" },
            {
              key: "requestRootfs",
              value: `${
                  quota_select?.spec.quotas.requestRootfs || quota_select?.spec.quotas.requestRootfs === '0' ?
                      (quota_select?.spec.quotas.requestRootfs !== "Unlimited" ? change_unit(quota_select?.spec.quotas.requestRootfs, unit_provide, false).toFixed(2) : "Unlimited")
                      : "Unlimited"
                  } ${unit_provide}`,
            },
            {
              key: "limitsRootfs",
              value: `${
                  quota_select?.spec.quotas.limitsRootfs || quota_select?.spec.quotas.limitsRootfs === '0' ?
                      (quota_select?.spec.quotas.limitsRootfs !== "Unlimited" ? change_unit(quota_select?.spec.quotas.limitsRootfs, unit_provide, false).toFixed(2) : "Unlimited")
                      : "Unlimited"
                  } ${unit_provide}`,
            },
            {
              key: "PVC Disk",
              value: `${
                quota_select?.spec.quotas.limitsDisk || quota_select?.spec.quotas.limitsDisk === '0' ?
                  (quota_select?.spec.quotas.limitsDisk !== "Unlimited" ? change_unit(quota_select?.spec.quotas.limitsDisk, unit_provide, false).toFixed(2) : "Unlimited")
                  : "Unlimited"
                } ${unit_provide}`,
            },
            {
              key: "PVC",
              value: `${
                quota_select?.spec.quotas.persistentvolumeclaims || quota_select?.spec.quotas.persistentvolumeclaims === '0' ?
                  (quota_select?.spec.quotas.persistentvolumeclaims !== "Unlimited" ? quota_select?.spec.quotas.persistentvolumeclaims : "Unlimited")
                  : "Unlimited"
                }`,
            },
            { key: "Empty02", value: `&nbsp;` },
            { key: "Empty03", value: `&nbsp;` },
          ],
        },
        {
          key: "object_count_quota",
          value: [
            // { key: "object_count_quota", value: "object_count_quota" },
            { key: "services", value: quota_select?.spec.quotas.services || quota_select?.spec.quotas.services === '0' ? (quota_select?.spec.quotas.services !== "Unlimited" ? quota_select?.spec.quotas.services : "Unlimited") : "Unlimited" },
            { key: "secrets", value: quota_select?.spec.quotas.secrets || quota_select?.spec.quotas.secrets === '0' ? (quota_select?.spec.quotas.secrets !== "Unlimited" ? quota_select?.spec.quotas.secrets : "Unlimited") : "Unlimited" },
            { key: "configMaps", value: quota_select?.spec.quotas.configmaps || quota_select?.spec.quotas.configmaps === '0' ? (quota_select?.spec.quotas.configmaps !== "Unlimited" ? quota_select?.spec.quotas.configmaps : "Unlimited") : "Unlimited" },
            { key: "pods", value: quota_select?.spec.quotas.pods || quota_select?.spec.quotas.pods === '0' ? (quota_select?.spec.quotas.pods !== "Unlimited" ? quota_select?.spec.quotas.pods : "Unlimited") : "Unlimited" },
            { key: "Empty04", value: `&nbsp;` },
            { key: "Empty05", value: `&nbsp;` },
          ],
        },
      ];
    }

    const physical_resource_usage_new_second: JSX.Element[] = [];

    for (let i = 0; i < quota_data.length; i++) {
      const key = quota_data[i].key;
      const value = quota_data[i].value;
      physical_resource_usage_new_second[i] = (
        <Col sm={8} className="quota_usage" key={key}>
          <div className="quota_usage_border">
            <div className="expand_quota_title quota_usage_title">{upper_case(key)}</div>
            <Descriptions bordered size="small" column={{ sm: 2 }}>
              {value.map((quota) => (
                <Descriptions.Item
                  className={`w-140 text-ellipsis w-max-120 ${quota.key.includes("Empty") ? "opacity-0" : ""}`}
                  label={<span>{quota.key.includes("Empty") ? `\xa0` : quota.key}</span>}
                  span={quota.key.indexOf("_") > -1 ? 3 : 1}
                  key={quota.key + "_item"}
                >
                  {typeof quota.value === "string" && quota.value.indexOf("_") > -1 ? (
                    // <span>
                    //     {upper_case(quota.value)}
                    // </span>
                    <FormattedMessage id={quota.value} />
                  ) : typeof quota.value === "string" && quota.value.includes("&") ? (
                    `\xa0`
                  ) : (
                    <span title={quota && quota.value && quota.value.indexOf("Unlimited") > -1 ? "Unlimited" : quota.value}>
                      {quota && quota.value && quota.value.indexOf("Unlimited") > -1 ? "Unlimited" : quota.value}
                    </span>
                  )}
                </Descriptions.Item>
              ))}
            </Descriptions>
          </div>
        </Col>
      );
    }

    if (path.includes("scale") || path.includes("quotas")) {
      const binded_workspaces: space_item[] | undefined =
          Array.isArray(workspaces) && workspaces
            ? workspaces
                .filter((workspace) => workspace && workspace.spec && workspace.spec.workspacequota === quota_select?.metadata.name)
                .map((workspace) => ({ space: workspace.metadata.labels.name, uid: workspace.metadata.uid }))
            : [],
        binded_namespaces: space_item[] | undefined =
          Array.isArray(namespaces) && namespaces
            ? namespaces
                .filter((namespace) => namespace && namespace.metadata.labels && namespace.metadata.labels.namespacequota === quota_select?.metadata.name)
                .map((namespace) => ({ space: namespace.metadata.name, uid: namespace.metadata.uid }))
            : [];

      const is_workspace = path.indexOf("workspace") > -1,
        is_quota = path.includes("quota"),
        bind_spaces = is_workspace ? binded_workspaces : binded_namespaces,
        filter_bind_spaces: space_item[] | undefined =
          Array.isArray(bind_spaces) && bind_spaces
            ? bind_spaces.filter((space) => space.space.toLocaleLowerCase().indexOf(filter_bind_name.trim().toLocaleLowerCase()) > -1)
            : [],
        filter_namespaces: space_item[] | undefined =
          Array.isArray(namespaces) && namespaces
            ? namespaces
                .filter((space) => space.metadata.name.toLocaleLowerCase().indexOf(filter_name.trim().toLocaleLowerCase()) > -1)
                .map((space) => ({ space: space.metadata.name, uid: space.metadata.uid, labels: space.metadata.labels }))
            : [],
        filter_workspaces: space_item[] | undefined =
          Array.isArray(workspaces) && workspaces
            ? workspaces
                .filter((space) => space.metadata.labels.name.toLocaleLowerCase().indexOf(filter_name.trim().toLocaleLowerCase()) > -1)
                .map((space) => ({ space: space.metadata.labels.name, uid: space.metadata.uid, name: space.metadata.name }))
            : [],
        spaces = (is_workspace
          ? filter_workspaces
          : filter_namespaces.filter(
              (namespace: space_item) => (namespace.labels as namespaces_type_item["metadata"]["labels"])?.workspace === workspace_selected?.name
            )
        ).filter((space_1: space_item): boolean => !filter_bind_spaces.find(({ space }: space_item) => space_1.space === space)),
        bind_space_search = (
          <div style={{ padding: 8 }} onClick={(e) => e.stopPropagation()}>
            <Input
              value={will_filter_bind_name}
              onChange={(e: any) => {
                set_will_filter_bind_name(e.target.value);
              }}
              onPressEnter={() => {
                set_filter_bind_name(will_filter_bind_name);
              }}
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Button
              type="primary"
              onClick={() => {
                set_filter_bind_name(will_filter_bind_name);
              }}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90, marginRight: 8 }}
            >
              Search
            </Button>
            <Button
              onClick={() => {
                set_filter_bind_name("");
                set_will_filter_bind_name("");
              }}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </div>
        ),
        space_search = (
          <div style={{ padding: 8 }} onClick={(e) => e.stopPropagation()}>
            <Input
              value={will_filter_name}
              onChange={(e: any) => {
                set_will_filter_name(e.target.value);
              }}
              onPressEnter={() => {
                set_filter_name(will_filter_name);
              }}
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Button
              type="primary"
              onClick={() => {
                set_filter_name(will_filter_name);
              }}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90, marginRight: 8 }}
            >
              Search
            </Button>
            <Button
              onClick={() => {
                set_filter_name("");
                set_will_filter_name("");
              }}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </div>
        );
      const space_column: ColumnProps<any>[] = [
        {
          title: (
            <Row>
              <Col sm={16}>{is_workspace ? <FormattedMessage id="workspace_unbind" /> : <FormattedMessage id="namespace_unbind" />}</Col>
              <Col sm={8} className="text-right">
                <Popover content={space_search} trigger="hover" placement="bottomRight">
                  <SearchOutlined className="pointer font-9 px-6" />
                </Popover>
              </Col>
            </Row>
          ),
          dataIndex: "space",
          width: "40%",
          key: `${is_workspace ? "workspace" : "namespace"}`,
          render: (name) => {
            return {
              children: <span>{name}</span>,
              props: {
                "data-title": `${is_workspace ? "Workspace: " : "Namespace: "}`,
              },
            };
          },
        },
        {
          title: "Uid",
          dataIndex: "uid",
          key: "uid",
          render: (uid) => {
            return {
              children: <span>{uid}</span>,
              props: {
                "data-title": "Uid: ",
              },
            };
          },
        },
      ];

      const bind_space_column: ColumnProps<any>[] = [
        {
          title: (
            <Row>
              <Col sm={16}>{is_workspace ? <FormattedMessage id="workspace_bind" /> : <FormattedMessage id="namespace_bind" />}</Col>
              <Col sm={8} className="text-right">
                <Popover content={bind_space_search} trigger="hover" placement="bottomRight">
                  <SearchOutlined className="pointer font-9 px-6" />
                </Popover>
              </Col>
            </Row>
          ),
          dataIndex: "space",
          width: "40%",
          key: `${is_workspace ? "workspace" : "namespace"}`,
          render: (name) => {
            return {
              children: <span>{name}</span>,
              props: {
                "data-title": `${is_workspace ? "Workspace: " : "Namespace: "}`,
              },
            };
          },
        },
        {
          title: (
            <Row>
              <Col sm={11}>Uid</Col>
              <Col sm={13} className="text-right">
                {is_quota && bind_spaces && bind_spaces.length !== 0 && <ExportOutlined className="px-20 export" onClick={() => export_space_datas()} />}
              </Col>
            </Row>
          ),
          dataIndex: "uid",
          key: "uid",
          render: (uid) => {
            return {
              children: <span>{uid}</span>,
              props: {
                "data-title": "Uid: ",
              },
            };
          },
        },
      ];

      const export_space_datas = () => {
        interface data_table_type {
          WorkspaceQuota?: string;
          Workspaces?: string;
          NamespaceQuota?: string;
          Namespaces?: string;
          uid: string;
          UID: string;
        }
        let option: any = [
          { fileName: "", datas: [{ sheetName: "", sheetHeader: [""], sheetData: [{ Workspaces: "", UID: "" }], sheetFilter: [""], columnWidths: [""] }] },
        ];
        let dataTable: data_table_type[] = [];
        if (bind_spaces)
          for (let key in bind_spaces) {
            if (is_workspace) {
              dataTable.push({
                WorkspaceQuota: quota_select?.metadata.name,
                uid: quota_select?.metadata.uid || "",
                Workspaces: bind_spaces[key].space,
                UID: bind_spaces[key].uid,
              });
            } else {
              dataTable.push({
                NamespaceQuota: quota_select?.metadata.name,
                uid: quota_select?.metadata.uid || "",
                Namespaces: bind_spaces[key].space,
                UID: bind_spaces[key].uid,
              });
            }
          }

        option.fileName = `${is_workspace ? "workspaces" : "namespaces"} of binded to ${quota_select?.metadata.name}`;
        option.datas = [
          {
            sheetData: dataTable,
            sheetName: `binded ${is_workspace ? "workspaces" : "namespaces"}`,
            sheetHeader: [`${is_workspace ? "WorkspaceQuota" : "NamespaceQuota"}`, "uid", `${is_workspace ? "Workspaces" : "Namespaces"}`, "UID"],
            columnWidths: [10, 20, 20, 40],
          },
        ];

        let toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
      };

      const onSelectChange = (selectedRowKeys: any[], selectedRows: any) => {
        set_selectedRowKeys(selectedRowKeys);
        set_selectedRows(selectedRows);
      };

      const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: "40px",
      };

      const paginationProps = {
        pageSize: page_size,
        showSizeChanger: true,
        pageSizeOptions: ["5", "20", "50", "100"],
        showTotal: () => <FormattedMessage id="total_items" values={{ value: spaces ? spaces.length : 0 }} />,
        onShowSizeChange: (_current: number, pageSize: number) => {
          set_page_size(pageSize);
        },
      };

      const paginationPropsBind = {
        pageSize: bind_page_size,
        showSizeChanger: true,
        showTotal: () => <FormattedMessage id="total_items" values={{ value: bind_spaces ? bind_spaces.length : 0 }} />,
        pageSizeOptions: ["5", "20", "50", "100"],
        onShowSizeChange: (_current: number, pageSize: number) => {
          set_bind_page_size(pageSize);
        },
      };

      const assign = async (quota_name: string | undefined) => {
        if (user_info.role && datacenter_name) {
          set_is_spinning(true);
          let promise_all: unknown[] = [];
          for (let i = 0; i < selectedRows.length; i++) {
            const row: any = selectedRows[i];
            const promise: Promise<void | unknown> | unknown = is_workspace
              ? await http_request(
                  "scalequotas",
                  props,
                  set_workspaces,
                  `/v1/datacenter/${datacenter_name}/cluster/${(cluster_selected || {}).name || ""}/workspace/${row.name}`,
                  2,
                  user_info.role,
                  user_info.subscription_id,
                  datacenter_name,
                  (cluster_selected || {}).name || "",
                  { metadata: { name: row.space }, spec: { workspacequota: quota_name } }
                )
              : await http_request(
                  "scalequotas",
                  props,
                  set_namespaces,
                  `/v1/datacenter/${datacenter_name}/cluster/${(cluster_selected || {}).name || ""}/namespace/${row.space}`,
                  2,
                  user_info.role,
                  user_info.subscription_id,
                  datacenter_name,
                  (cluster_selected || {}).name || "",
                  { metadata: { labels: { namespacequota: quota_name, workspace: row.labels && row.labels.workspace } } }
                );

            promise_all.push(promise);
          }

          Promise.all(promise_all).finally(() => {
            const is_fresh_new = is_fresh;
            set_is_fresh(!is_fresh_new);
            set_is_spinning(false);
          });
        }
      };

      const handle_ok = () => {
        assign(quota_select?.metadata.name);
        set_visible(false);
      };

      const handle_cancel = () => {
        set_visible(false);
      };

      const quota_table = (
        <Col sm={24} className={`small_table mt-20 bind_table ${is_quota ? "fix_height" : ""}`} key="quota_table">
          <Modal
            title={<FormattedMessage id="batch_assign" />}
            visible={visible}
            onOk={handle_ok}
            onCancel={handle_cancel}
            destroyOnClose={true}
            okText={<FormattedMessage id="ok" />}
            cancelText={<FormattedMessage id="cancel" />}
          >
            <FormattedMessage
              id="are_you_sure_to_map_the_key_to_quota"
              values={{ key: is_workspace ? <FormattedMessage id="workspace" /> : <FormattedMessage id="namespace" /> }}
            ></FormattedMessage>
            <b>{quota_select?.metadata.name}</b>?
          </Modal>
          <Collapse expandIcon={({ isActive }) => <RightOutlined rotate={isActive ? 90 : 0} />}>
            <Panel
              header={
                <span className="font-gray">
                  {path.includes("scale") && bind_spaces && bind_spaces.length === 0 ? (
                    <FormattedMessage id="no_any_been_assigned" />
                  ) : (
                    <FormattedMessage
                      id="view_these_binded_key_and_export_them_quotas"
                      values={{
                        key: is_workspace ? <FormattedMessage id="workspace" /> : <FormattedMessage id="namespace" />,
                        quotas: path.includes("quotas") ? <FormattedMessage id="and_bath_assign" /> : "",
                      }}
                    />
                  )}
                </span>
              }
              key="services"
              style={{ background: "#1890ff0f", borderRadius: 4, marginBottom: 20 }}
              extra={
                !is_quota && bind_spaces && bind_spaces.length !== 0 ? (
                  <Fragment>
                    <ExportOutlined
                      className="px-20 export"
                      onClick={(e: any) => {
                        e.stopPropagation();
                        export_space_datas();
                      }}
                    />
                  </Fragment>
                ) : (
                  ""
                )
              }
              disabled={path.includes("scale") && bind_spaces && bind_spaces.length === 0}
            >
              <Spin spinning={is_spinning} size="large" indicator={<LoadingOutlined style={{ color: "#1890ffb5" }} />}>
                <Row justify="start" align="middle">
                  {is_quota ? (
                    <Fragment>
                      <Col sm={11} style={{top: '13px'}}>
                        <Table
                          className="second-table-header"
                          columns={space_column}
                          dataSource={spaces}
                          pagination={paginationProps}
                          size="small"
                          rowSelection={rowSelection}
                          rowKey={(space) => space.uid}
                          scroll={{ y: 240 }}
                          showSorterTooltip={false}
                        />
                      </Col>
                      <Col sm={2} className={`text-center assign_btn ${selectedRowKeys.length === 0 ? "disabled_btn" : ""}`}>
                        <Button className="plain_button" onClick={() => set_visible(true)} disabled={selectedRowKeys.length === 0}>
                          <RightOutlined className="pointer" />
                        </Button>
                      </Col>
                    </Fragment>
                  ) : (
                    ""
                  )}
                  <Col sm={is_quota ? 11 : 24} style={{top: '13px'}}>
                    <Table
                      className="second-table-header"
                      columns={bind_space_column}
                      dataSource={filter_bind_spaces}
                      pagination={paginationPropsBind}
                      size="small"
                      rowKey={(space) => space.uid}
                      scroll={{ y: 240 }}
                      showSorterTooltip={false}
                    />
                  </Col>
                </Row>
              </Spin>
            </Panel>
          </Collapse>
        </Col>
      );

      physical_resource_usage_new_second.push(quota_table);
    }

    set_physical_resource_usage(physical_resource_usage_new_second);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    is_spinning,
    is_fresh,
    set_is_fresh,
    bind_page_size,
    selectedRows,
    set_namespaces,
    set_workspaces,
    visible,
    page_size,
    quota_select,
    quotas,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    workspace_selected?.name,
    workspaces,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    namespace_selected?.name,
    namespaces,
    path,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    quota_select?.spec.quotas.configmaps,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    quota_select?.spec.quotas.limitCPU,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    quota_select?.spec.quotas.limitsDisk,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    quota_select?.spec.quotas.limitMemory,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    quota_select?.spec.quotas.limitsRootfs,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    quota_select?.spec.quotas.persistentvolumeclaims,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    quota_select?.spec.quotas.pods,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    quota_select?.spec.quotas.secrets,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    quota_select?.spec.quotas.services,
    set_table_list_modal,
    filter_name,
    will_filter_name,
    filter_bind_name,
    will_filter_bind_name,
    selectedRowKeys,
    user_info.role,
    user_info.subscription_id,
    unit_provide,
    cluster_selected,
  ]);

  return <Row>{physical_resource_usage}</Row>;
};

export function upTimeFormat(updateTime: string): string {
  //time format from YYYY-MM-DD HH:mm:ss +00:00 UTC to YYYY-MM-DDTHH:mm:ssZ
  let UTCstring = updateTime.slice(0, updateTime.indexOf(" ")) + "T" + updateTime.slice(updateTime.indexOf(" ") + 1, updateTime.indexOf("+") - 1) + "Z";
  let local_time = new Date(UTCstring);
  return `${local_time.toLocaleDateString()} ${local_time.toLocaleTimeString("en-US", { hour12: false })}`;
}

export function upper_case(key: string): string {
  return key
    .split("_")
    .map((item) => item.charAt(0).toUpperCase() + item.substr(1) + " ")
    .toString()
    .replace(/,/g, "");
}

const WorkspaceOverview: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [workspaces, set_workspaces]: [
      workspaces_type_item[] | undefined,
      React.Dispatch<React.SetStateAction<workspaces_type_item[] | undefined>>
    ] = useContext(WorkspaceContext),
    [quotas, set_quotas]: [quota_type["items"], React.Dispatch<React.SetStateAction<quota_type["items"]>>] = useContext(QuotaContext),
    workspace_selected: item | undefined = useContext(WorkSpaceSelectedContext)[0],
    set_left_menu_items: React.Dispatch<React.SetStateAction<left_menu_item[]>> = useContext(LeftMenuContext)[1],
    set_left_menu_title: React.Dispatch<React.SetStateAction<string>> = useContext(LeftMenuTitleContext)[1],
    [side_fly_in, set_side_fly_in]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useContext(SideFlyInContext),
    user_info: IUserInfoType = useContext(UserInfoContext)[0],
    datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
    unit_provide: string = useContext(UnitContext)[0],
    cluster_selected: item | undefined = useContext(ClusterSelectedContext)[0],
    [type_name, set_type_name]: [string | undefined, React.Dispatch<React.SetStateAction<string | undefined>>] = useContext(TypeNameContext),
    theme: string = useContext(ThemeContext)[0],
    [workspace_info, set_workspace_info]: [workspace_info_type, React.Dispatch<React.SetStateAction<workspace_info_type>>] = useState(
      {} as workspace_info_type
    ),
    [workspace_info_panel, set_workspace_info_panel]: [JSX.Element[], React.Dispatch<React.SetStateAction<JSX.Element[]>>] = useState([] as JSX.Element[]),
    [physical_resource_usage, set_physical_resource_usage]: [JSX.Element[], React.Dispatch<React.SetStateAction<JSX.Element[]>>] = useState(
      [] as JSX.Element[]
    ),
    [metric_data, set_metric_data]: [metric_values_new, React.Dispatch<React.SetStateAction<metric_values_new>>] = useState({} as metric_values_new),
    { formatMessage } = useMemo(() => props.intl, [props]);
  type metric_key_type = keyof metric_values;

  useEffect(() => {
    // 切换订阅号，当type_name为undefined
    !type_name &&
      (cluster_selected?.labels?.type === "dedicate" || cluster_selected?.labels?.type === "shared") &&
      set_type_name(cluster_selected?.labels?.type);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [set_type_name, cluster_selected?.labels?.type]);

  useEffect((): void => {
    if (user_info.role !== "" && cluster_selected && datacenter_name)
      http_request(
        "workspaces",
        props,
        set_workspaces,
        `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspaces`,
        0,
        user_info.role,
        user_info.subscription_id,
        datacenter_name,
        cluster_selected.name || "",
        undefined,
        undefined,
        undefined,
        undefined,
        true
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cluster_selected?.name, user_info.role, user_info.subscription_id, set_workspaces]);

  useEffect((): void => {
    if (user_info.role !== "" && cluster_selected && datacenter_name)
      http_request(
        "workspacequotas",
        props,
        set_quotas,
        `/v1/datacenter/${datacenter_name}/cluster/${cluster_selected.name}/workspacequotas`,
        0,
        user_info.role,
        user_info.subscription_id,
        datacenter_name,
        cluster_selected.name || ""
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cluster_selected?.name, user_info.role, user_info.subscription_id, set_workspaces]);

  useEffect((): void => {
    if (user_info.role !== "" && workspace_selected?.name && datacenter_name) {
      (async () => {
        set_workspace_info(
          (await http_request(
            "workspace_info",
            props,
            undefined,
            `/v1/datacenter/${datacenter_name}/cluster/${(cluster_selected || {}).name || ""}/workspace/${workspace_selected.name}/info`,
            0,
            user_info.role,
            user_info.subscription_id,
            datacenter_name,
            (cluster_selected || {}).name || "",
            undefined,
            undefined,
            undefined,
            undefined,
            true
          )) as workspace_info_type
        );
      })();
      workspace_selected.name &&
        http_request(
          "workspace_metric",
          props,
          set_metric_data,
          `/v1/datacenter/${datacenter_name}/cluster/${(cluster_selected || {}).name || ""}/workspace/${workspace_selected.name}/metric`,
          0,
          user_info.role,
          user_info.subscription_id,
          datacenter_name,
          (cluster_selected || {}).name || ""
        );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cluster_selected?.name, workspace_selected?.name, set_metric_data, user_info.role, user_info.subscription_id]);

  useEffect((): void => {
    set_left_menu_title("Workspace");
    set_left_menu_items(menu_items[1]);
  }, [set_left_menu_title, set_left_menu_items, workspaces, workspace_selected]);

  useEffect(
    (): void => {
      if (workspace_info) {
        const workspace_info_panel_new: JSX.Element[] = [],
          // workspace_info_new = workspace_info as unknown as workspace_info_type,
          workspace: workspaces_type_item | undefined = workspaces && workspaces.filter((workspace) => workspace_selected?.name === workspace.metadata.name)[0],
          quota_name: string | undefined = workspace && workspace.spec?.workspacequota,
          quota: quota_type_item = quotas.filter((qu) => qu.metadata.name === quota_name)[0],
          workspace_info_arr: string[] | undefined = [
            `${formatMessage({ id: "namespaces" })}`,
            workspace_info.totalNamespaces || "",
            `${formatMessage({ id: "quota" })}`,
            quota_name ? quota_name : "",
            "Pod",
            workspace_info.usedPod ? Number(workspace_info.usedPod).toFixed(0) : "",
            "Service",
            workspace_info.usedService ? workspace_info.usedService : "",
            "Secret",
            workspace_info.usedSecret ? workspace_info.usedSecret : "",
            "ConfigMap",
            workspace_info.usedConfigmap ? workspace_info.usedConfigmap : "",
            "CPU",
            workspace_info.usedCPU ? `${Number(workspace_info.usedCPU).toFixed(2)} core` : "",
            `${formatMessage({ id: "memory" })}`,
            workspace_info.usedMemory ? `${change_unit(workspace_info.usedMemory, unit_provide, false)} ${unit_provide}` : "",
            'GPU',
            workspace_info.usedGPU || "",
            `${formatMessage({ id: "update_time" })}`,
            workspace_info.updateTime && Number(workspace_info.updateTime) ? formatDate(Number(workspace_info.updateTime)) : "",
          ];

        for (let i = 0; i < workspace_info_arr.length; i += 2) {
          const is_namespaces: boolean = workspace_info_arr[i] === `${formatMessage({ id: "namespaces" })}`;
          workspace_info_panel_new[i] = (
            <Col
              className={`resource_card no-pad ${is_namespaces ? "pointer" : ""} justify-center align-items-center ${
                workspace_info_arr[i] === "Update Time" ? "flex-2" : "flex-1"
              }`}
              key={workspace_info_arr[i]}
              onClick={() => is_namespaces && props.history.push(`/workspace-info/namespaces`)}
            >
              <Row className="resource_info d-flex border">
                <Col className={`strong text-ellipsis ${workspace_info_arr[i] === "Uptime" ? "time_break" : ""}`} title={workspace_info_arr[i + 1]}>
                  {workspace_info_arr[i + 1] || (
                    <Skeleton className="ant-col-sm-16 ant-col-sm-offset-4" title={{ width: "100%" }} paragraph={{ rows: 0 }} active />
                  )}
                </Col>
                <Col className="span info_title text-ellipsis">{workspace_info_arr[i]}</Col>
              </Row>
            </Col>
          );
        }
        set_workspace_info_panel(workspace_info_panel_new);

        const physical_resource_usage_new_first: JSX.Element[] = [],
          physical_resource_usage_arr: string[] | undefined = [
            "CPU",
            workspace_info.usedCPU ? Number(workspace_info.usedCPU).toFixed(2) : "",
            workspace_info.totalCPU ? `${workspace_info.totalCPU === "*" ? "*" : Number(workspace_info.totalCPU).toFixed(2)}` : "",
            "usedCPU",
            "Memory",
            workspace_info.usedMemory ? `${change_unit(workspace_info.usedMemory, unit_provide, false)}` : "",
            workspace_info.totalMemory ? `${workspace_info.totalMemory === "*" ? "*" : change_unit(workspace_info.totalMemory, unit_provide, false)}` : "",
            "usedMemory",
            "Rootfs",
            workspace_info.usedRootfs ? `${change_unit(workspace_info.usedRootfs, unit_provide, false)}` : "",
            workspace_info.totalRootfs ? `${workspace_info.totalRootfs === "*" ? "*" : change_unit(workspace_info.totalRootfs, unit_provide, false)}` : "",
            "usedRootfs",
            "Pod",
            workspace_info.usedPod ? Number(workspace_info.usedPod).toFixed(0) : "",
            workspace_info.totalPod ? workspace_info.totalPod : "",
            "usedPod",
            "PVC Disk",
            workspace_info.usedDisk ? `${change_unit(workspace_info.usedDisk, unit_provide, false)}` : "",
            workspace_info.totalDisk ? `${workspace_info.totalDisk === "*" ? "*" : change_unit(workspace_info.totalDisk, unit_provide, false)}` : "",
            "usedDisk",
          ];
        // get_float: (num: number) => number = (num: number): number => parseFloat(num.toFixed(3));
        let name: string,
          used: number,
          total: number,
          usage_display: string,
          used_str: string,
          total_str: string,
          metric_key: metric_key_type,
          unit: string,
          metric_data_each: object[];
        for (let i = 0; i < physical_resource_usage_arr.length; i += 4) {
          used_str = physical_resource_usage_arr[i + 1];
          total_str = physical_resource_usage_arr[i + 2]
            ? physical_resource_usage_arr[i + 2].indexOf("*") === -1
              ? physical_resource_usage_arr[i + 2]
              : "Unlimited"
            : "";
          used = used_str ? (used_str.indexOf(" ") === -1 ? Number(used_str) : Number(used_str.slice(0, used_str.indexOf(" ")))) : 0;
          total = total_str
            ? total_str.indexOf(" ") === -1
              ? total_str.indexOf("*") === -1
                ? Number(total_str)
                : 1
              : Number(total_str.slice(0, total_str.indexOf(" ")))
            : 1;
          usage_display = physical_resource_usage_arr[i + 1];
          metric_key = physical_resource_usage_arr[i + 3] as metric_key_type;
          name = physical_resource_usage_arr[i];
          unit = name === "CPU" || name === "Pod" ? "" : unit_provide;
          metric_data_each =
            metric_key === "usedCPU" || metric_key === "usedPod"
              ? metric_data[metric_key]?.data
              : metric_data[metric_key] && (metric_data[metric_key][unit_provide] as object[]);
          const interval: number =
            (metric_key === "usedCPU" || metric_key === "usedPod"
              ? metric_data[metric_key]?.interval
              : metric_data[metric_key] && (metric_data[metric_key].interval as number)) || 0;

          physical_resource_usage_new_first[i] = (
            <Col className="cluster_status_card" key={name}>
              <Row className="cluster_status_row">
                <Col sm={6}>
                  <CircularProgressbar
                    value={total_str === "Unlimited" ? 0 : used}
                    maxValue={total === 0 || total_str === "Unlimited" ? Infinity : total}
                    strokeWidth={12}
                    text={`${total_str === "Unlimited" ? "Unlimited" : total === 0 ? "0.00%" : `${((used / total) * 100).toFixed(2)}%`}`}
                    className="progress_circle"
                    styles={buildStyles({ trailColor: `${theme === 'black_gray' ? 'dcdce0' : 'dcdce0'}` })}
                  />
                </Col>
                <Col sm={18}>
                  <Row className="status_detail">
                    <Col sm={24} className="font-w-6 text-ellipsis">
                      {formatMessage({ id: physical_resource_usage_arr[i].toLocaleLowerCase().replace(" ", "_") })}
                    </Col>
                    <Col
                      sm={24}
                      className="d-flex align-items-center"
                      title={`${Number(usage_display) ? usage_display : "0"} / ${total ? total.toString() : total_str} ${
                        name === "CPU" ? "core" : name === "Pod" ? "" : unit_provide
                      }`}
                    >
                      <span className="font-w-6 font-20 text-ellipsis">
                        {usage_display
                          ? Number(usage_display)
                            ? usage_display
                            : "0"
                          : "" || <Skeleton className="ant-col pr-6" title={{ width: "50px" }} paragraph={{ rows: 0 }} active />}
                      </span>
                      <span className="px-6 vertical-middle">/</span>
                      <span className="text_total_span_skeleton text-ellipsis">
                        {total_str
                          ? total
                            ? total.toString()
                            : total_str
                          : "" || <Skeleton className="ant-col pr-6" title={{ width: "50px" }} paragraph={{ rows: 0 }} active />}
                      </span>
                      <span className="pl-4 vertical-middle">{name === "CPU" ? "core" : name === "Pod" ? "" : unit_provide}</span>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="">
                <ResponsiveContainer width="90%" height={180}>
                  <LineChart data={metric_data_each}>
                    <XAxis dataKey="time" />
                    <YAxis
                      label={{ value: `${unit}`, angle: 0, position: "insideTop" }}
                      domain={[(dataMin) => (dataMin - interval).toFixed(2), (dataMax) => (dataMax + interval / 2).toFixed(2)]}
                      allowDataOverflow={false}
                      interval="preserveStart"
                    />
                    <CartesianGrid strokeDasharray="3 3" />
                    <Tooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      dot={false}
                      dataKey={name}
                      stroke={theme === "dark_blue" ? "#2E7BBF" : theme === "black_gray" ? "#6c748b" : "#4fa1e8"}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </Row>
            </Col>
          );
        }

        const physical_resource_quota_new: JSX.Element[] = [],
          physical_resource_quota_arr: string[] = [
            // "compute_resource_quota",
            "compute_resource_quota",
            "requestCPU",
            quota === undefined ? "Unlimited" : quota.spec.quotas.requestCPU ? quota.spec.quotas.requestCPU + " Core" : "Unlimited",
            "limitsCPU",
            quota === undefined ? "Unlimited" : quota.spec.quotas.limitCPU ? quota.spec.quotas.limitCPU + " Core" : "Unlimited",
            "requestMemory",
            `${
              quota === undefined
                ? "Unlimited"
                : quota.spec.quotas.requestMemory
                ? `${
                    quota.spec.quotas.requestMemory === "*" ? "Unlimited" : change_unit(quota.spec.quotas.requestMemory, unit_provide, false).toFixed(2)
                  } ${unit_provide}`
                : "Unlimited"
            }`,
            "limitsMemory",
            `${
              quota === undefined
                ? "Unlimited"
                : quota.spec.quotas.limitMemory
                ? `${
                    quota.spec.quotas.limitMemory === "*" ? "Unlimited" : change_unit(quota.spec.quotas.limitMemory, unit_provide, false).toFixed(2)
                  } ${unit_provide}`
                : "Unlimited"
            }`,
            "GPU",
            quota === undefined ? "Unlimited" : quota.spec.quotas.gpu || "Unlimited",
            // "storage_resource_quota",
            "storage_resource_quota",
            "requestRootfs",
            `${
                quota?.spec?.quotas?.requestRootfs || quota?.spec?.quotas?.requestRootfs === '0' ?
                    (quota?.spec.quotas.requestRootfs !== "Unlimited" ? `${change_unit(quota?.spec.quotas.requestRootfs, unit_provide, false).toFixed(2)} ${unit_provide}` : "Unlimited")
                    : "Unlimited"
                }`,
            "limitsRootfs",
            `${
                quota?.spec?.quotas?.limitsRootfs || quota?.spec?.quotas?.limitsRootfs === '0' ?
                    (quota?.spec.quotas.limitsRootfs !== "Unlimited" ? `${change_unit(quota?.spec.quotas.limitsRootfs, unit_provide, false).toFixed(2)} ${unit_provide}` : "Unlimited")
                    : "Unlimited"
                }`,
            "PVC Disk",
            `${
              quota === undefined
                ? "Unlimited"
                : quota.spec.quotas.limitsDisk
                ? `${
                    quota.spec.quotas.limitsDisk === "*" ? "Unlimited" : change_unit(quota.spec.quotas.limitsDisk, unit_provide, false).toFixed(2)
                  } ${unit_provide}`
                : "Unlimited"
            }`,
            "PVC",
            `${
              quota === undefined
                ? "Unlimited"
                : quota.spec.quotas.persistentvolumeclaims
                ? `${quota.spec.quotas.persistentvolumeclaims === "*" ? "Unlimited" : quota.spec.quotas.persistentvolumeclaims}`
                : "Unlimited"
            }`,
            "\xa0",
            "\xa0",
            // "object_count_quota",
            "object_count_quota",
            "services",
            quota === undefined ? "Unlimited" : quota.spec.quotas.services ? quota.spec.quotas.services : "Unlimited",
            "secrets",
            quota === undefined ? "Unlimited" : quota.spec.quotas.secrets ? quota.spec.quotas.secrets : "Unlimited",
            "configMaps",
            quota === undefined ? "Unlimited" : quota.spec.quotas.configmaps ? quota.spec.quotas.configmaps : "Unlimited",
            "pods",
            quota === undefined ? "Unlimited" : quota.spec.quotas.pods ? quota.spec.quotas.pods : "Unlimited",
            "\xa0",
            "\xa0"
          ];

        let keys: string,
          // value: string,
          first_label: string,
          first_value: string,
          second_label: string,
          second_value: string,
          third_label: string,
          third_value: string,
          fourth_label: string,
          fourth_value: string,
          fifth_label: string,
          fifth_value: string;
        for (let a = 0; a < physical_resource_quota_arr.length; a += 11) {
          keys = physical_resource_quota_arr[a];
          // value = physical_resource_quota_arr[a + 1];
          first_label = physical_resource_quota_arr[a + 1];
          first_value = physical_resource_quota_arr[a + 2];
          second_label = physical_resource_quota_arr[a + 3];
          second_value = physical_resource_quota_arr[a + 4];
          third_label = physical_resource_quota_arr[a + 5];
          third_value = physical_resource_quota_arr[a + 6];
          fourth_label = physical_resource_quota_arr[a + 7];
          fourth_value = physical_resource_quota_arr[a + 8];
          fifth_label = physical_resource_quota_arr[a + 9];
          fifth_value = physical_resource_quota_arr[a + 10];
          physical_resource_quota_new[a] = (
            <Col xs={24} md={12} lg={8} className="quota_usage" key={keys}>
              <div className="quota_usage_border">
                <div className="quota_usage_title"><FormattedMessage id={keys} /></div>
                <Descriptions bordered size="small" column={{ xxl: 2, xl: 1, lg: 1, md: 1, sm: 2, xs: 1 }}>
                  {/* <Descriptions.Item
                    className="text-ellipsis"
                    label={keys.includes("&") ? `\xa0` : <FormattedMessage id={value} />}
                    span={3}
                    key={keys + `${a}`}
                  >
                    {value.includes("&") ? `\xa0` : <FormattedMessage id={value} />}
                  </Descriptions.Item> */}
                  <Descriptions.Item className={`text-ellipsis`} label={<span>{first_label}</span>} span={1} key={first_label + `${a + 1}`}>
                    {first_value.includes("&") ? `\xa0` : <span title={first_value}>{first_value}</span>}
                  </Descriptions.Item>
                  <Descriptions.Item className={`text-ellipsis`} label={<span>{second_label}</span>} span={1} key={second_label + `${a + 2}`}>
                    {second_value.includes("&") ? `\xa0` : <span title={second_value}>{second_value}</span>}
                  </Descriptions.Item>
                  <Descriptions.Item className={`text-ellipsis`} label={<span>{third_label}</span>} span={1} key={third_label + `${a + 3}`}>
                    {third_value.includes("&") ? `\xa0` : <span title={third_value}>{third_value}</span>}
                  </Descriptions.Item>
                  <Descriptions.Item className={`text-ellipsis`} label={<span>{fourth_label}</span>} span={1} key={fourth_label + `${a + 4}`}>
                    {fourth_value.includes("&") ? `\xa0` : <span title={fourth_value}>{fourth_value}</span>}
                  </Descriptions.Item>
                  <Descriptions.Item className={`text-ellipsis`} label={<span>{fifth_label}</span>} span={1} key={fifth_label + `${a + 5}`}>
                    {fifth_value.includes("&") ? `\xa0` : <span title={fifth_value}>{fifth_value}</span>}
                  </Descriptions.Item>
                </Descriptions>
              </div>
            </Col>
          );
        }

        set_physical_resource_usage([
          <div key="phy_usage">
            <div className="grid grid_first">{physical_resource_usage_new_first}</div>
            <Row className="mt-20">{physical_resource_quota_new}</Row>
          </div>,
        ]);
      }
    },
    // eslint-disable-next-line
    [metric_data, unit_provide, workspace_info, formatMessage, theme]
  );

  return (
    <Col sm={24}>
      <Row className="box_rounded card_title pointer breadcrumb_sticky">
        <Col sm={1}>
          {side_fly_in ? (
            <MenuUnfoldOutlined
              className="pl-10 mt-5"
              onClick={() => {
                set_side_fly_in(!side_fly_in);
              }}
            />
          ) : (
            <MenuFoldOutlined
              className="pl-10 mt-5"
              onClick={() => {
                set_side_fly_in(!side_fly_in);
              }}
            />
          )}
        </Col>
        <Col sm={22} pull={1} className="px-30">
          <BreadCrumbs />
        </Col>
      </Row>
      <Row className="px-6">
        <Col sm={24} className="px-6 mb-5">
          <DropdownMenuTop />
        </Col>
        <Col sm={24} className="card box_rounded border">
          <Row>
            <Col sm={24} className="card_title card_underline">
              <FormattedMessage id="resource_information" />
            </Col>
            <Col sm={24} className="res_info">
              <Row>{workspace_info_panel}</Row>
              <LineChart />
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="px-6">
        <Col lg={24} className="card box_rounded border">
          <div className="card_title card_underline">
            <FormattedMessage id="physical_resource_usage" />
          </div>
          {physical_resource_usage}
        </Col>
      </Row>
    </Col>
  );
};

export default injectIntl(withRouter(WorkspaceOverview) as any);
